import axios from "./axiosInstance";

export async function viewInvoicePdf(invoiceId) {
  const res = await axios.get(`/admin/invoices/${invoiceId}/pdf`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export async function downloadInvoicePdf(invoice, invoiceId) {
  const id = invoiceId ?? invoice?._id;
  if (!id) return;
  const res = await axios.get(`/admin/invoices/${id}/pdf`, {
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  const fileNameParts = [];
  if (invoice?.invoiceNumber) fileNameParts.push(invoice.invoiceNumber);
  if (invoice?.supplierName) fileNameParts.push(invoice.supplierName);
  const baseName = fileNameParts.join(" - ").trim() || `invoice-${String(id)}`;
  link.href = url;
  link.download = `${baseName}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
